/**
 * トップページ: 体験予約・モデルコーススライド
 */

import { waitForImagesLoad, adjustSlideButtonPosition } from '../utils';

/**
 * 共通スライド設定
 */
const commonSlideSettings = {
  slidesToShow: 4,
  slidesToScroll: 4,
  infinite: true,
  arrows: true,
  dots: false,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        centerMode: true,
        centerPadding: '1%',
      },
    },
  ],
};

/**
 * スライドセクションの初期化
 * @param {jQuery} $ - jQuery
 * @param {string} sectionClass - セクションのクラス名（例: 's-home__activities'）
 * @returns {Object} ボタン位置調整関数を含むオブジェクト
 */
function initSlideSection($, sectionClass) {
  const $slide = $(`.${sectionClass} .s-home__slide`);

  if ($slide.length === 0) return null;

  // ボタン位置調整関数
  function adjustButtonPosition() {
    adjustSlideButtonPosition($slide, '.c-slide__item', '.s-home__card-figure');
  }

  // スライド初期化
  $slide
    .slick({
      ...commonSlideSettings,
      centerMode: sectionClass === 's-home__activities' ? false : undefined,
    })
    .on('init reInit', function () {
      setTimeout(adjustButtonPosition, 100);
    });

  // 画像読み込み完了後に位置調整
  const $images = $slide.find('.s-home__card-figure img');
  waitForImagesLoad($images, adjustButtonPosition);

  return { adjustButtonPosition };
}

/**
 * 体験予約セクションの初期化
 * @param {jQuery} $ - jQuery
 */
export function initActivities($) {
  return initSlideSection($, 's-home__activities');
}

/**
 * モデルコースセクションの初期化
 * @param {jQuery} $ - jQuery
 */
export function initCourses($) {
  return initSlideSection($, 's-home__courses');
}
